<!--
 * @Descripttion: 进度条组件
 * @Author: zenghua.wang
 * @Date: 2021-12-17 10:28:08
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-23 15:59:16
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
    v-if="!option.hide"
  >
    <template v-if="option.type==='line'">
      <div :class="setClass('bar')">
        <div
          :class="setClass('bar__outer')"
          :style="{height: option.strokeWidth +'px'}"
        >
          <div
            :class="setClass('bar__inner')"
            :style="styleBar"
          >
          </div>
        </div>
      </div>
      <div
        :class="setClass('bar__text')"
        :style="styleFont"
      >{{percentage}}%</div>
    </template>

    <div
      :class="setClass('circle')"
      v-else
    >
      <svg viewBox="0 0 100 100">
        <path
          :class="setClass('circle__track')"
          :d="trackPath"
          stroke="#e5e9f2"
          fill="none"
          stroke-linecap="round"
          :stroke-width="relativeStrokeWidth"
          :style="trailPathStyle"
        ></path>
        <path
          :class="setClass('circle__path')"
          :d="trackPath"
          :stroke="option.stroke"
          fill="none"
          stroke-linecap="round"
          :stroke-width="percentage ? relativeStrokeWidth : 0"
          :style="circlePathStyle"
        ></path>
      </svg>
      <div
        :class="setClass('circle__text')"
        :style="styleFont"
      >
        <span>{{percentage}}%</span>
        <p></p>
      </div>
    </div>

  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import { component } from '@/dragComponents/model/default.js'
import { setPx, isEmpty } from '@/dragComponents/utils'
import mock from '@/dragComponents/model/mock.js'

export default {
  name: 'drag-progress',
  mixins: [bem],
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    apiId: {
      type: [Number, String]
    },
    width: {
      type: [Number, String],
      default: 160
    },
    height: {
      type: [Number, String],
      default: 160
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataList: [],
      loading: false,
      handle: null,
      percentage: 0
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width: setPx(this.width),
          height: this.option.type === 'line' ? 'auto' : setPx(this.height),
          padding: setPx(this.option.padding)
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleBar() {
      return {
        width: this.percentage + '%',
        backgroundColor: this.option.stroke
      }
    },
    styleFont() {
      return {
        fontSize: setPx(this.option.fontSize),
        color: this.option.color
      }
    },
    relativeStrokeWidth() {
      return ((this.option.strokeWidth / this.width) * 100).toFixed(1)
    },
    radius() {
      if (this.option.type === 'circle' || this.option.type === 'dashboard') {
        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10)
      } else {
        return 0
      }
    },
    trackPath() {
      const radius = this.radius
      const isDashboard = this.option.type === 'dashboard'
      return `
          M 50 50
          m 0 ${isDashboard ? '' : '-'}${radius}
          a ${radius} ${radius} 0 1 1 0 ${isDashboard ? '-' : ''}${radius * 2}
          a ${radius} ${radius} 0 1 1 0 ${isDashboard ? '' : '-'}${radius * 2}
          `
    },
    perimeter() {
      return 2 * Math.PI * this.radius
    },
    rate() {
      return this.option.type === 'dashboard' ? 0.75 : 1
    },
    strokeDashoffset() {
      const offset = (-1 * this.perimeter * (1 - this.rate)) / 2
      return setPx(offset)
    },
    trailPathStyle() {
      return {
        strokeDasharray: `${this.perimeter * this.rate}px, ${this.perimeter}px`,
        strokeDashoffset: this.strokeDashoffset
      }
    },
    circlePathStyle() {
      return {
        strokeDasharray: `${
          this.perimeter * this.rate * (this.percentage / 100)
        }px, ${this.perimeter}px`,
        strokeDashoffset: this.strokeDashoffset,
        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
      }
    }
  },
  watch: {
    apiId() {
      this.loadDataList()
    },
    'option.refresh'(val) {
      if (val) this.loadDataList()
    }
  },
  methods: {
    getName() {
      if (isEmpty(this.option.column)) return null
      let list = this.option.column.filter((item) => {
        return item.type === 'name'
      })
      if (isEmpty(list)) {
        return null
      } else {
        return list[0]['prop']
      }
    },
    getValue() {
      if (isEmpty(this.option.column)) return []
      let list = this.option.column.filter((item) => {
        return item.type === 'value'
      })
      return list
    },
    async loadDataList() {
      if (!this.apiId) {
        this.init()
        return
      }

      // 参数设置
      let restParams = []
      let query = {}
      let resultValue = this.getValue()
      // let resultName = this.getName()

      // 过滤条件
      this.option.reqParams.map((item, index) => {
        // 外部条件、参数
        if (!isEmpty(item.key) && !isEmpty(this.$route.query[item.key])) {
          query[item.prop] = this.$route.query[item.key]
        }

        // 固定值、登录人等非空查询
        if (!isEmpty(item.value)) {
          query[item.prop] = item.value
        }
      })

      try {
        this.loading = true
        let res = await this.$http({
          method: this.option.reqMethod,
          url: mock.getUrl(false) + this.apiId,
          data: restParams, // body
          params: query // query
        })
        if (!isEmpty(res.data)) {
          this.dataList = res.data
          let json = Array.isArray(this.dataList)
            ? this.dataList[0]
            : this.dataList
          if (!isEmpty(resultValue)) {
            this.percentage = json[resultValue[0]['prop']]
            this.title = resultValue[0]['label']
          }
          this.onRefresh()
        }
      } catch (err) {
        this.$message.error(err.msg)
      } finally {
        this.loading = false
        this.option.refresh = false
      }
    },
    init() {
      this.percentage = 50
    },
    onRefresh() {
      this.handle && clearInterval(this.handle)
      this.handle = null
      if (this.option.refreshTime > 0 && this.disabled) {
        this.handle = setInterval(() => {
          this.loadDataList()
        }, this.option.refreshTime)
      }
    }
  },
  created() {
    this.loadDataList()
  }
}
</script>
<style lang="scss" scoped>
.drag-progress {
  position: relative;
  box-sizing: border-box;

  &-bar {
    padding-right: 50px;
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    margin-right: -55px;
    box-sizing: border-box;

    &__outer {
      height: 16px;
      border-radius: 100px;
      background-color: #ebeef5;
      overflow: hidden;
      position: relative;
      vertical-align: middle;
    }

    &__inner {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #409eff;
      text-align: right;
      border-radius: 100px;
      line-height: 1;
      white-space: nowrap;
      transition: width 0.6s ease;
    }

    &__text {
      display: inline-block;
      vertical-align: middle;
      color: #999;
      font-size: 12px;
      margin-left: 10px;
      font-size: 14px;
    }
  }

  &-circle {
    &__text {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      text-align: center;
      margin: 0;
      transform: translateY(-50%);
      color: #999;
    }
  }
}
</style>
